




























import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    graphData: Array
  }
})
export default class PVGraph extends Vue {
  private graphData: any;
  private graphSeries: any = [];
  private graphKey = 0;
  private isActive = [false, false, false, false];
  private yLabel = "Power (W)";
  private yData = {
    title: {
      text: this.yLabel
    },
    labels: {
      formatter: function() {
        return (this as any).value;
      }
    }
  };

  private chartOptions = {
    title: {
      text: ""
    },
    chart: {
      type: "line"
    },
    subtitle: {
      text: ""
    },
    tooltip: {
      formatter: function() {
        const time = new Date((this as any).x * 1000);
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
        let minutes = time.getMinutes();
        let hour = time.getHours();
        let date = time.getDate();
        let month = time.getMonth();
        let minutesString = "";
        let hourString = "";
        if (minutes < 10) {
          minutesString = "0" + minutes.toString();
        } else {
          minutesString = minutes.toString();
        }
        if (hour < 10) {
          hourString = "0" + hour.toString();
        } else {
          hourString = hour.toString();
        }
        return (
          "Inverter #: <b>" +
          this.series.name +
          "</b><br>" +
          "Time: <b>" +
          date +
          "  " +
          monthNames[month] +
          "  " +
          hourString +
          ":" +
          minutesString +
          "<br>Value: <b>" +
          Math.round((this as any).y) +
          "</b>"
        );
      }
    },
    exporting: {
      enabled: true,
      csv: {
        columnHeaderFormatter: null,
        dateFormat: "%Y-%m-%d %H:%M:%S",
        decimalPoint: null,
        itemDelimiter: null,
        lineDelimiter: " "
      },
      buttons: {
        contextButton: {
          menuItems: ["downloadPNG", "downloadSVG", "downloadXLS"]
        }
      }
    },
    yAxis: this.yData,
    xAxis: {
      title: {
        text: "Time"
      },
      labels: {
        formatter: function() {
          const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ];
          const time = new Date((this as any).value * 1000);
          let minutes = time.getMinutes();
          let hour = time.getHours();
          let date = time.getDate();
          let month = time.getMonth();
          let minutesString = "";
          let hourString = "";
          if (minutes < 10) {
            minutesString = "0" + minutes.toString();
          } else {
            minutesString = minutes.toString();
          }
          if (hour < 10) {
            hourString = "0" + hour.toString();
          } else {
            hourString = hour.toString();
          }
          return (
            date +
            "  " +
            monthNames[month] +
            "  " +
            hourString +
            ":" +
            minutesString
          );
        }
      }
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle"
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false
        }
      }
    },

    series: this.graphSeries,

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom"
            }
          }
        }
      ]
    }
  };

  changeData(x) {
    this.graphSeries.length = 0;
    for (let i = 0; i < 4; i++) {
      if (i == x) this.isActive[i] = true;
      else this.isActive[i] = false;
    }
    if (x == 0) {
      this.yLabel = "Power (W)";
      for (let i = 0; i < this.graphData.length; i++) {
        let data = [];
        for (let j = 0; j < this.graphData[i].length; j++) {
          data.push([
            this.graphData[i][j].timestamp,
            this.graphData[i][j].powergenerated
          ] as never);
        }
        if (this.graphData[i].length > 0){
            this.graphSeries.push({
            name: this.graphData[i][0].inverterserialid,
            data: data,
            visible: false
          });
        }
      }
    } else if (x == 1) {
      this.yLabel = "Current (A)";
      for (let i = 0; i < this.graphData.length; i++) {
        let data1 = [];
        let data2 = [];
        for (let j = 0; j < this.graphData[i].length; j++) {
          data1.push([
            this.graphData[i][j].timestamp,
            parseFloat(this.graphData[i][j].p1Amp)
          ] as never);
          data2.push([
            this.graphData[i][j].timestamp,
            parseFloat(this.graphData[i][j].p2Amp)
          ] as never);
        }
        if (this.graphData[i].length > 0){
          this.graphSeries.push({
            name: this.graphData[i][0].inverterserialid + " 1",
            data: data1,
            visible: false
          });

          this.graphSeries.push({
            name: this.graphData[i][0].inverterserialid + " 2",
            data: data2,
            visible: false
          });
        }
      }
    } else if (x == 2) {
      this.yLabel = "Power (W)";
      for (let i = 0; i < this.graphData.length; i++) {
        let data1 = [];
        let data2 = [];
        for (let j = 0; j < this.graphData[i].length; j++) {
          data1.push([
            this.graphData[i][j].timestamp,
            parseFloat(this.graphData[i][j].p1power)
          ] as never);
          data2.push([
            this.graphData[i][j].timestamp,
            parseFloat(this.graphData[i][j].p2power)
          ] as never);
        }

        if (this.graphData[i].length > 0){
        this.graphSeries.push({
          name: this.graphData[i][0].inverterserialid + " 1",
          data: data1,
          visible: false
        });

        this.graphSeries.push({
          name: this.graphData[i][0].inverterserialid + " 2",
          data: data2,
          visible: false
        });
        }
      }
    } else if (x == 3) {
      this.yLabel = "Voltage (V)";
      for (let i = 0; i < this.graphData.length; i++) {
        let data1 = [];
        let data2 = [];
        for (let j = 0; j < this.graphData[i].length; j++) {
          data1.push([
            this.graphData[i][j].timestamp,
            parseFloat(this.graphData[i][j].p1Current)
          ] as never);
          data2.push([
            this.graphData[i][j].timestamp,
            parseFloat(this.graphData[i][j].p2Current)
          ] as never);
        }
        if (this.graphData[i].length > 0){
        this.graphSeries.push({
          name: this.graphData[i][0].inverterserialid + " 1",
          data: data1,
          visible: false
        });

        this.graphSeries.push({
          name: this.graphData[i][0].inverterserialid + " 2",
          data: data2,
          visible: false
        });
        }
      }
    }

    this.chartOptions.yAxis = {
      title: {
        text: this.yLabel
      },
      labels: {
        formatter: function() {
          return (this as any).value;
        }
      }
    };

    this.graphSeries[0].visible = true;

    this.graphKey++;
  }

  mounted() {
    setTimeout(() => this.changeData(0), 1000);
  }

  updated() {}
}
